// extracted by mini-css-extract-plugin
export var centerText = "_5r-8";
export var container = "_5r-0";
export var doughnutContainer = "_5r-7";
export var legend = "_5r-a";
export var legendItemColorDisplay = "_5r-b";
export var legendItemLabel = "_5r-d";
export var legendItemValue = "_5r-c";
export var lg = "_5r-5";
export var maxWidth = "_5r-9";
export var md = "_5r-4";
export var responsive = "_5r-6";
export var sm = "_5r-3";
export var xs = "_5r-2";
export var xxs = "_5r-1";